import React, { useState } from 'react';
import { View, StyleSheet, ScrollView, Pressable } from 'react-native';
import I18n from '../../../../../components/shared/i18n/I18n.component';
import colors from '../../../../../config/colors';
import HeaderContainer from '../../../../../components/shared/Header/Header.container';
import WebHeader from '../../../../../components/shared/Header/WebHeader.component';
import ImageIcon from '../../../../../components/shared/Icon/ImageIcon.component';
import MiniCard from './MiniCard/MiniCard.component';
import DataSummaryPanel from '../DataSummaryPanel/DataSummaryPanel.component';
import TableContainer from '../../../../../components/web/ReactTable/Table.container';
import MiniBarCardComponent from './MiniBarCard/MiniBarCard.component';
import CompareModal from '../CompareModal.component';
import GenericDropdown from '../Dropdown.component';
import { i18nService } from '../../../../../services/i18n.service';

const WorkingTimeReportDetailComponent = (props: any) => {
	const {
		route,
		navigation,
		id,
		data,
		compareData,
		companyTableData,
		companyTableHeaders,
		companyPieData,
		compareClientTableHeader,
		miniCardsData,
		barChartData,
		handleExcel,
		menuMode,
		handleReset,
		handleCompareData,
		dateLabels,
		companyColorMapping,
	} = props;
	const [modalVisible, setModalVisible] = useState(false);
	const displayName = data?.employeeName || 'No employee data available';

	return (
		<>
			<HeaderContainer
				navigation={navigation}
				containerStyle={{ backgroundColor: colors.white }}
				component={WebHeader}
			/>
			<ScrollView style={styles.container}>
				<View style={styles.topSection}>
					<View style={styles.title}>
						<Pressable
							onPress={props.handleGoBack}
							style={({ hovered }) => [
								styles.backButton,
								hovered && styles.backButtonHover,
							]}
						>
							<ImageIcon name={'chevronRight'} />
						</Pressable>

						<I18n size={20} weight='normal'>
							repReports.workingTimeReportDetail.title
						</I18n>
						<I18n size={20} weight='normal'>
							{` ${displayName}`}
						</I18n>
					</View>

					<View style={styles.filters}>
						<I18n size={14} weight='400'>
							period
						</I18n>
						<GenericDropdown  
							options={props.timeRangeOptions}
							onChange={props.handleChange}
							mode='list'
						/>
						<GenericDropdown
							key={props.menuMode}
							mode={props.menuMode}
							onChange={props.handleDateChange}
						/>
					</View>
				</View>

				<View style={styles.cardsWrapper}>
					<MiniCard
						title={i18nService.translate('worktime')}
						value={miniCardsData.totalHours}
						icon={'miniClock'}
					/>
					<MiniCard
						title={i18nService.translate('dataReceivedAboutCompany')}
						value={miniCardsData.dataReceivedAboutCompany}
						icon={'fileDots'}
					/>
					<MiniCard
						title={i18nService.translate('averageCompanyWorkingTime')}
						value={miniCardsData.averageCompanyWorkingTime}
						icon={'miniClock'}
					/>
				</View>

				<DataSummaryPanel
					title={
						'repReports.workingTimeReports.timeAndDelivery.Company'
					}
					pieTitle={
						'repReports.workingTimeReports.timeAndDelivery.CompanyChart'
					}
					tableHeaders={companyTableHeaders}
					tableData={companyTableData}
					pieData={companyPieData}
					tableClickable={false}
					footer={true}
					navigation={navigation}
					excelExportHandler={handleExcel}
				/>

				<View style={{ marginVertical: 16 }}>
					<View style={styles.middleTitle}>
						<I18n size={20} weight='normal'>
							repReports.workingTimeReportDetail.comparison
						</I18n>

						<View style={styles.buttonWrapper}>
							<Pressable
								onPress={() => {
									handleReset();
								}}
								style={({ hovered }) => [
									styles.resetButton,
									hovered && styles.resetButtonHover,
								]}
							>
								<ImageIcon name={'refresh'} />
								<I18n
									size={15}
									weight='400'
									color={colors.titlePrimary}
								>
									general.reset
								</I18n>
							</Pressable>

							<Pressable
								onPress={() => {
									setModalVisible(true);
								}}
								style={({ hovered }) => [
									styles.compareButton,
									hovered && styles.compareButtonHover,
								]}
							>
								<ImageIcon name={'AB'} />
								<I18n weight='400' size={14} color='white'>
									general.compare
								</I18n>
							</Pressable>
						</View>
					</View>

					<CompareModal
						modalVisible={modalVisible}
						setModalVisible={setModalVisible}
						onCompare={handleCompareData}
						onReset={() => {}}
					/>

					<TableContainer
						headers={compareClientTableHeader}
						data={compareData}
						keyName={'id_' + Date.now()}
						getNextData={() => {}}
						onSort={() => {}}
						onRowClick={() => {}}
						hasFooter={true}
						windowScale={1}
						//allDataFetched={allFetched}
						//getUpdatedDataFromTable={() => {}}
						// outerClasses={{
						//     footerRowRoot: classes.customFooterRow,
						//     footerCellRoot: classes.customFooterCell,
						// }}
						//defaultExpandedRows={{ '0': true }}
						//showExpandHeader={true}
					/>

					<View style={styles.cardsWrapper}>
						<MiniBarCardComponent
							title={'worktime'}
							barChartData={barChartData.workingTimeData}
							companyColorMapping={companyColorMapping}
						/>
						<MiniBarCardComponent
							title={'payslips'}
							barChartData={barChartData.paycheckBarData}
							companyColorMapping={companyColorMapping}
						/>
						<MiniBarCardComponent
							title={'101forms'}
							barChartData={barChartData.form101BarData}
							companyColorMapping={companyColorMapping}
						/>
					</View>
				</View>


			</ScrollView>
		</>
	);
};

const styles = StyleSheet.create({
	container: {
		paddingVertical: 32,
		paddingHorizontal: 32,
		overflow: 'scroll',
	},
	topSection: {
		display: 'flex',
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: 24,
	},
	middleTitle: {
		display: 'flex',
		flexDirection: 'row-reverse',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 16,
	},
	title: {
		display: 'flex',
		justifyContent: 'flex-start',
		flexDirection: 'row-reverse',
		direction: 'ltr', // fix bug MPD-1073 (next we should fix all the app to allow correctly rtl)
		alignItems: 'center',
	},
	filters: {
		display: 'flex',
		flexDirection: 'row-reverse',
		alignItems: 'center',
		gap: 16,
	},
	cardsWrapper: {
		display: 'flex',
		flexDirection: 'row-reverse',
		width: '100%',
		gap: 16,
		marginVertical: 48,
	},
	resetButton: {
		display: 'flex',
		flexDirection: 'row-reverse',
		padding: 11,
		borderRadius: 10,
		justifyContent: 'center',
		alignItems: 'center',
		gap: 10,
	},
	resetButtonHover: {
		backgroundColor: colors.secondaryLight,
	},
        backButton: {
        display: 'flex',
        flexDirection: 'row-reverse',
        padding: 11,
        borderRadius: 10,
        justifyContent: 'center',
        alignItems: 'center',
        gap: 10
    },
    backButtonHover: {
        backgroundColor: colors.secondaryLight,
    },
	compareButton: {
		display: 'flex',
		flex: 1,
		flexDirection: 'row-reverse',
		backgroundColor: colors.titlePrimary,
		paddingHorizontal: 25,
		paddingVertical: 9,
		marginLeft: 15,
		borderRadius: 10,
		height: 31,
		gap: 10,
		justifyContent: 'center',
		alignItems: 'center',
	},
	compareButtonHover: {
		backgroundColor: colors.primaryDark,
	},
	buttonWrapper: {
		display: 'flex',
		flexDirection: 'row-reverse',
		justifyContent: 'center',
		alignItems: 'center',
		gap: 24,
	},
	button: {
		backgroundColor: '#007AFF',
		padding: 15,
		borderRadius: 8,
	},
	buttonText: {
		color: '#ffffff',
		fontSize: 16,
	},
});

export default WorkingTimeReportDetailComponent;
